/* eslint-disable no-param-reassign */
const nodeList: HTMLElement[] = [];
const ctxKey = Symbol('clickoutside');

let startClick: MouseEvent | null = null;
let seed = 0;

if (typeof window !== 'undefined') {
    document.addEventListener('mousedown', (e) => {
        startClick = e;
    });

    document.addEventListener('mouseup', (e) => {
        nodeList.forEach((node) => {
            const ctx = (node as any)[ctxKey];
            ctx?.documentHandler?.(e, startClick);
        });
    });
}

function createDocumentHandler(
    el: HTMLElement,
    binding: any,
) {
    // eslint-disable-next-line func-names
    return function (mouseup: MouseEvent = {} as MouseEvent, mousedown: MouseEvent = {} as MouseEvent) {
        const composedPath = (e: MouseEvent) => e?.composedPath?.() || [];

        const mouseupTarget = composedPath(mouseup)[0] || mouseup.target;
        const mousedownTarget = composedPath(mousedown)[0] || mousedown.target;

        const { handler, include = [] } = typeof binding.value === 'function'
            ? { handler: binding.value, include: [] }
            : binding.value;

        const shouldIgnore = include.some((refOrEl: any) => {
            const targetEl = refOrEl?.$el ?? refOrEl;
            return targetEl?.contains(mouseupTarget) || targetEl?.contains(mousedownTarget);
        });

        if (shouldIgnore) return;

        if (typeof handler === 'function') {
            handler();
        }
    };
}

export default {
    beforeMount(el: HTMLElement, binding: any) {
        const id = seed++;
        (el as any)[ctxKey] = {
            id,
            documentHandler: createDocumentHandler(el, binding),
            iFrameListener: () => {
                const handler = typeof binding.value === 'function'
                    ? binding.value
                    : binding.value?.handler;
                if (
                    document.activeElement?.tagName === 'IFRAME' &&
          typeof handler === 'function'
                ) {
                    handler();
                }
            },
        };
        nodeList.push(el);
        window.addEventListener('blur', (el as any)[ctxKey].iFrameListener);
    },

    updated(el: HTMLElement, binding: any) {
        const ctx = (el as any)[ctxKey];
        if (ctx) {
            ctx.documentHandler = createDocumentHandler(el, binding);
        }
    },

    unmounted(el: HTMLElement) {
        const ctx = (el as any)[ctxKey];
        const index = nodeList.findIndex((n) => (n as any)[ctxKey]?.id === ctx?.id);
        if (index !== -1) nodeList.splice(index, 1);
        window.removeEventListener('blur', ctx?.iFrameListener);
        delete (el as any)[ctxKey];
    },
};
